import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { HeaderNavigationQuery } from "../../types/graphql-types"
import Home from "../assets/icons/umr/home.svg"
import { NavigationList, LinkItem } from "./navigation"

export const HeaderNavigation = () => {
  const data: HeaderNavigationQuery = useStaticQuery(
    graphql`
      query HeaderNavigation {
        navigationYaml(id: { eq: "header" }) {
          ...Navigation
        }
      }
    `
  ).navigationYaml?.navigation

  let menuItemCommonClass =
    "inline-block hover:text-umr-grey-900 hover:bg-umr-grey-050 border-b-4 pt-4 px-4 pb-4 h-full "
  let menuItemClass =
    menuItemCommonClass + "hover:border-umr-grey-050 border-fb12-blue-400"
  return (
    <nav>
      <div class="bg-fb12-blue-400">
        <div class="mx-auto max-w-4xl md:max-w-6xl px-4">
          <div class="bg-fb12-blue-400 text-white text-xl border-t border-fb12-blue-300 fill-current">
            <NavigationList
              data={data}
              liClassName="h-16"
              renderItem={item => (
                <div class="h-full">
                  <LinkItem
                    item={item}
                    className={menuItemClass}
                    activeClassName={
                      menuItemCommonClass +
                      "text-white bg-fb12-blue-350 border-white hover:border-white"
                    }
                    itemRenderer={item =>
                      item.label === "Home" ? (
                        <Home class="h-6 fill-current" />
                      ) : (
                        item.label
                      )
                    }
                  />
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </nav>
  )
}
